const LineItemBeingEditedKey = 'line-item-being-edited';
const CampaignBeingEditedKey = 'campaign-being-edited';
const OriginalRoute = 'original-route';

export default class SessionCache {
  static getItem(key: string) {
    const data = window.sessionStorage.getItem(key);
    if (data != null) {
      return JSON.parse(data);
    }
    return null;
  }

  static setItem(key: string, val) {
    if (val != null) {
      window.sessionStorage.setItem(key, JSON.stringify(val));
    } else {
      window.sessionStorage.removeItem(key);
    }
  }

  static get lineItemBeingEdited() {
    return SessionCache.getItem(LineItemBeingEditedKey);
  }

  static set lineItemBeingEdited(val) {
    SessionCache.setItem(LineItemBeingEditedKey, val);
  }

  static get campaignBeingEdited() {
    return SessionCache.getItem(CampaignBeingEditedKey);
  }

  static get originalRoute() {
    return SessionCache.getItem(OriginalRoute);
  }

  static set originalRoute(val) {
    SessionCache.setItem(OriginalRoute, val);
  }
}
